import { render, staticRenderFns } from "./blockList.vue?vue&type=template&id=5157a816&scoped=true"
import script from "./blockList.vue?vue&type=script&lang=js"
export * from "./blockList.vue?vue&type=script&lang=js"
import style0 from "./blockList.vue?vue&type=style&index=0&id=5157a816&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5157a816",
  null
  
)

export default component.exports